import { render, staticRenderFns } from "./SimpleDigitalSignature.vue?vue&type=template&id=4601d8a6&scoped=true&"
import script from "./SimpleDigitalSignature.vue?vue&type=script&lang=js&"
export * from "./SimpleDigitalSignature.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDigitalSignature.vue?vue&type=style&index=0&id=4601d8a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601d8a6",
  null
  
)

export default component.exports